module.exports = __webpack_public_path__ + "img/classic_5.14803dff.png";